export const configStorage = () => {
  if(localStorage.getItem('checked') === 'true') {
    return localStorage.getItem('jwtToken')
  }else {
    return  sessionStorage.getItem('jwtToken')
  }
};